import { jsxs as M, jsx as l } from "react/jsx-runtime";
import { E as d, S as p } from "./icons.types-0722eef5.js";
function H({ title: t, titleId: i, size: h, width: a, height: E, extended: m = !1, ...f }) {
  const Z = m ? d : p, s = h ? Z[h] : a || Z[m ? "s" : "l"], v = h ? Z[h] : E || Z[m ? "s" : "l"];
  return /* @__PURE__ */ M(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: s,
      height: v,
      "aria-labelledby": i,
      ...f,
      children: [
        t ? /* @__PURE__ */ l("title", { id: i, children: t }) : null,
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#EC1C24",
            d: "M30 20.756v3.38h37.965c-.053-1.09-.167-2.468-.575-3.38"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#E6E7E8",
            d: "M65.6 17.376H30v3.38h37.39c-.406-1.261-1.01-2.411-1.79-3.38Z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#EC1C24",
            d: "M58 13.996H30v3.38h35.6c-1.669-2.09-4.416-3.38-7.6-3.38Z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#E6E7E8",
            d: "M67.965 24.136H30v3.38h38v-2.253c0-.201-.013-.397-.019-.594-.004-.054-.01-.193-.016-.533Z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#EC1C24",
            d: "M30 30.896h38v-3.38H30v3.38Z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#E6E7E8",
            d: "M30 34.276h38v-3.38H30v3.38Z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#EC1C24",
            d: "M30 34.276h38v3.38H30v-3.38Z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#E6E7E8",
            d: "M4 37.656v3.38h64v-3.38H4Z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#EC1C24",
            d: "M4 41.036h64v3.38H4v-3.38Z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#E6E7E8",
            d: "M4.005 46.495s-.009.819.015 1.301h63.96c.028-.494.015-1.301.015-1.301l.005-2.08H4l.005 2.08Z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#EC1C24",
            d: "M14 57.996h44c3.193 0 5.847-1.16 7.66-3.44H6.33c1.872 2.33 4.576 3.44 7.665 3.44"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#E6E7E8",
            d: "M6.335 54.556h59.33a10.002 10.002 0 0 0 1.74-3.38h-62.8a10.4 10.4 0 0 0 1.735 3.38"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#EC1C24",
            d: "M4.6 51.176h62.8a14.4 14.4 0 0 0 .58-3.38H4.02c.099 1.156.191 2.029.58 3.38Z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#176496",
            d: "M30 13.996H14c-6.627 0-10 4.925-10 11v12.66h26v-23.66Z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#ffffff",
            d: "m6.798 19.972.544-.418.543.418-.211-.672.54-.411h-.667l-.207-.675-.206.675h-.667l.543.411-.212.672Zm3.594 0 .544-.418.543.418-.21-.672.54-.411h-.667l-.207-.675-.206.675h-.67l.544.411-.211.672Zm3.965 0 .543-.418.544.418-.211-.672.54-.411h-.663l-.21-.675-.207.675h-.663l.537.411-.21.672Zm3.936 0 .543-.418.544.418-.21-.672.54-.411h-.67l-.204-.675-.206.675h-.668l.542.411-.211.672Zm3.95 0 .544-.418.543.418-.21-.672.54-.411h-.668l-.206-.675-.206.675h-.667l.54.411-.21.672ZM8.71 21.727l.543-.417.543.417-.21-.671.54-.411H9.46l-.207-.674-.203.674h-.67l.54.411-.21.671Zm3.595 0 .543-.417.543.417-.21-.671.54-.411h-.672l-.201-.674-.207.674h-.667l.54.411-.21.671Zm3.965 0 .542-.417.543.417-.21-.671.54-.411h-.666l-.207-.674-.207.674h-.668l.54.411-.207.671Zm3.934 0 .544-.417.544.417-.213-.671.542-.411h-.667l-.207-.674-.205.674h-.668l.54.411-.21.671Zm3.955 0 .539-.417.543.417-.212-.671.542-.411h-.666l-.208-.674-.205.674h-.668l.54.411-.205.671Zm2.227-1.755.543-.418.544.418-.211-.672.54-.411h-.663l-.211-.675-.206.675h-.673l.547.411-.21.672ZM6.745 34.016l.544-.413.543.413-.21-.666.54-.412-.667.002-.208-.674-.204.674-.67-.002.542.412-.21.666Zm3.595 0 .543-.413.544.413-.211-.666.54-.412-.666.002-.208-.674-.205.674-.667-.002.54.412-.21.666Zm3.965 0 .543-.413.544.413-.211-.666.54-.412-.671.002-.203-.674-.206.674-.667-.002.54.412-.21.666Zm3.936 0 .543-.413.543.413-.207-.666.537-.412-.668.002-.206-.674-.206.674-.667-.002.54.412-.21.666Zm3.949 0 .544-.413.544.413-.208-.666.537-.412-.667.002-.207-.674-.205.674-.668-.002.54.412-.21.666Zm4.144 0 .543-.413.544.413-.211-.666.54-.412-.67.002-.204-.674-.206.674-.67-.002.544.412-.21.666ZM6.798 23.484l.544-.418.543.418-.211-.672.54-.411-.667.002-.207-.676-.206.676-.667-.002.543.411-.212.672Zm3.594 0 .544-.418.543.418-.21-.672.54-.411-.667.002-.207-.676-.206.676-.67-.002.544.411-.211.672Zm3.965 0 .543-.418.544.418-.211-.672.54-.411-.663.002-.21-.676-.207.676-.663-.002.537.411-.21.672Zm3.936 0 .543-.418.544.418-.21-.672.54-.411-.67.002-.204-.676-.206.676-.668-.002.542.411-.211.672Zm3.95 0 .544-.418.543.418-.21-.672.54-.411-.668.002-.206-.676-.206.676-.667-.002.54.411-.21.672ZM8.71 25.24l.543-.417.543.417-.21-.671.54-.413H9.46l-.207-.672-.203.672h-.67l.54.413-.21.671Zm3.595 0 .543-.417.543.417-.21-.671.54-.413h-.672l-.201-.672-.207.672h-.667l.54.413-.21.671Zm3.965 0 .542-.417.543.417-.21-.671.54-.413h-.666l-.207-.672-.207.672h-.668l.54.413-.207.671Zm3.934 0 .544-.417.544.417-.213-.671.542-.413h-.667l-.207-.672-.205.672h-.668l.54.413-.21.671Zm3.955 0 .539-.417.543.417-.212-.671.542-.413h-.666l-.208-.672-.205.672h-.668l.54.413-.205.671Zm2.227-1.756.543-.418.544.418-.211-.672.54-.411-.663.002-.211-.676-.206.676-.673-.002.547.411-.21.672ZM6.745 26.996l.544-.417.543.417-.211-.67.54-.412-.667.002-.207-.676-.204.676-.67-.002.542.412-.21.67Zm3.595 0 .543-.417.544.417-.211-.67.54-.412-.666.002-.208-.676-.205.676-.667-.002.539.412-.21.67Zm3.965 0 .543-.417.543.417-.21-.67.54-.412-.671.002-.203-.676-.206.676-.667-.002.54.412-.21.67Zm3.936 0 .542-.417.544.417-.207-.67.537-.412-.668.002-.206-.676-.206.676-.667-.002.54.412-.21.67Zm3.949 0 .544-.417.543.417-.207-.67.537-.412-.668.002-.206-.676-.205.676-.668-.002.54.412-.21.67ZM8.658 28.752l.543-.416.543.416-.21-.666.54-.414h-.668l-.206-.676-.205.676h-.668l.54.414-.21.666Zm3.595 0 .543-.416.543.416-.21-.666.54-.414h-.67l-.204-.676-.206.676h-.668l.542.414-.21.666Zm3.966 0 .54-.416.545.416-.214-.666.544-.414h-.667l-.207-.676-.206.676h-.668l.54.414-.207.666Zm3.93 0 .547-.416.544.416-.21-.666.539-.414h-.667l-.207-.676-.205.676h-.668l.54.414-.212.666Zm3.95 0 .547-.416.544.416-.211-.666.542-.414h-.667l-.208-.676-.206.676h-.668l.54.414-.212.666Zm2.235-1.756.543-.417.543.417-.21-.67.54-.412-.67.002-.204-.676-.206.676-.67-.002.544.412-.21.67Zm-19.59 3.513.545-.413.543.413-.211-.671.54-.412-.667.002-.207-.676-.204.676-.67-.002.542.412-.21.671Zm3.596 0 .543-.413.544.413-.211-.671.54-.412-.666.002-.208-.676-.205.676-.667-.002.539.412-.21.671Zm3.965 0 .543-.413.543.413-.21-.671.54-.412-.671.002-.203-.676-.206.676-.667-.002.54.412-.21.671Zm3.936 0 .542-.413.544.413-.207-.671.537-.412-.668.002-.206-.676-.206.676-.667-.002.54.412-.21.671Zm3.949 0 .544-.413.543.413-.207-.671.537-.412-.668.002-.206-.676-.205.676-.668-.002.54.412-.21.671ZM8.658 32.266l.543-.418.543.418-.21-.672.54-.408h-.668l-.206-.677-.205.677h-.668l.54.408-.21.672Zm3.595 0 .543-.418.543.418-.21-.672.54-.408h-.67l-.204-.677-.206.677h-.668l.542.408-.21.672Zm3.966 0 .54-.418.545.418-.214-.672.544-.408h-.667l-.207-.677-.206.677h-.668l.54.408-.207.672Zm3.93 0 .547-.418.544.418-.21-.672.539-.408h-.667l-.207-.677-.205.677h-.668l.54.408-.212.672Zm3.95 0 .547-.418.544.418-.211-.672.542-.408h-.667l-.208-.677-.206.677h-.668l.54.408-.212.672Zm2.235-1.757.543-.413.543.413-.21-.671.54-.412-.67.002-.204-.676-.206.676-.67-.002.544.412-.21.671Z"
          }
        )
      ]
    }
  );
}
export {
  H as UsaUnitedStates
};
